import { jsx as _jsx } from "react/jsx-runtime";
import Gleap from 'gleap';
import { useDependencies } from 'hooks';
import React from 'react';
import { AppRouter } from './AppRouter';
const App = ()=>{
    const { envProfileService, cookiesService } = useDependencies();
    const IS_PROD = envProfileService.envProfile === 'prod' || window.location.hostname === 'cb.abb-bank.az';
    React.useEffect(()=>{
        var _cookiesService_get_trim, _cookiesService_get, _cookiesService_get_trim1, _cookiesService_get1;
        const isAuthenticated = Boolean((_cookiesService_get = cookiesService.get('access')) === null || _cookiesService_get === void 0 ? void 0 : (_cookiesService_get_trim = _cookiesService_get.trim()) === null || _cookiesService_get_trim === void 0 ? void 0 : _cookiesService_get_trim.length) && Boolean((_cookiesService_get1 = cookiesService.get('refresh')) === null || _cookiesService_get1 === void 0 ? void 0 : (_cookiesService_get_trim1 = _cookiesService_get1.trim()) === null || _cookiesService_get_trim1 === void 0 ? void 0 : _cookiesService_get_trim1.length);
        if (isAuthenticated) {
            const key = IS_PROD ? 'ciF48MVFtLRVDyUn9zB6RmJIe0AFCXl9' : 'vYMURqSoVCH37EXvcZPaHAp8J7kJ4khS';
            Gleap.initialize(key);
            Gleap.setLanguage(cookiesService.get('lang'));
        }
        if (IS_PROD) {
            (function(w, d, s, l, i) {
                w[`${l}`] = w[`${l}`] || [];
                w[`${l}`].push({
                    'gtm.start': new Date().getTime(),
                    event: 'gtm.js'
                });
                const f = d.getElementsByTagName(s)[0];
                const j = d.createElement(s);
                const dl = l !== 'dataLayer' ? '&l=' + l : '';
                j.async = true;
                j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', 'GTM-W5JFRTX');
        }
    }, []);
    return /*#__PURE__*/ _jsx(AppRouter, {});
};
export default App;
